import axios from 'axios';
import cookie from '../../cookieHelper/cookie';

// Stories bound to any purchase of the central company.
export default async function getCompanyStories({ centralCompanyId, origin, page = 0, size = 10 }, signal) {
    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/getStoriesByCentralCompanyId`, {
        params: { centralCompanyId, origin, page, size, mediaType: 'mp4' },
        signal,
        headers: { Authorization: `Bearer ${cookie.getCookie(process.env.REACT_APP_COOKIE_NAME)}` },
    });
    const result = response.data;
    const data = Array.isArray(result?.data) ? result.data[ 0 ] : result?.data;
    if (String(result?.status?.code) !== '10200' || !Array.isArray(data?.stories)) {
        const error = new Error(result?.status?.message || 'Unable to load stories.');
        error.response = response;
        throw error;
    }
    return { stories: data.stories };
}

// The endpoint returns no total, so read pages until a short one comes back.
export async function getAllCompanyStories({ centralCompanyId, origin }, signal) {
    const size = 100;
    const stories = [];
    for (let page = 0; ; page += 1) {
        const result = await getCompanyStories({ centralCompanyId, origin, page, size }, signal);
        stories.push(...result.stories);
        if (result.stories.length < size) break;
    }
    return stories;
}
